import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const CommercialLoanInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section commercial-fin">
                <h2 className="other-pages-title">Commercial Loan</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/commercial-loan-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Commercial Loan</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is a Commercial Loan?</h2>

                <p className="info-loan-description-smco">
                    A commercial loan is a financing option designed for businesses to fund operations, expansion, or large purchases. These loans are typically used for buying commercial property, equipment, inventory, or refinancing existing debt. Offered by banks, credit unions, and online lenders, commercial loans provide businesses with the capital needed to grow and maintain competitiveness.
                    <br /><br />
                    Lenders assess the business's financial health, credit history, and repayment ability before approval. Loan amounts can range from thousands to millions, depending on the business size and needs. Repayment terms usually span 1 to 10 years for term loans, with options for shorter periods on lines of credit.
                    <br /><br />
                    Interest rates for commercial loans vary from 5% to 25% annually, influenced by the borrower's creditworthiness, loan type, and economic conditions. Secured loans often have lower rates due to collateral, while unsecured options carry higher rates. Additional fees may include origination fees, appraisal costs, and prepayment penalties.
                    <br /><br />
                    Commercial loans are essential for businesses in retail, hospitality, manufacturing, and services sectors. They enable investments in growth opportunities while maintaining cash flow. Businesses should carefully evaluate their borrowing needs, compare lenders, and ensure alignment with long-term financial goals.
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features of a Commercial Loan</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Flexible use:</strong> Funds can be used for real estate, equipment, working capital, or debt consolidation.</li>
                        <li><strong>Large amounts:</strong> Loans from ₹10 lakhs to ₹10 crores or more based on business requirements.</li>
                        <li><strong>Varied terms:</strong> Repayment periods from 1 to 10 years, with options for fixed or variable rates.</li>
                        <li><strong>Collateral options:</strong> Secured against business assets, real estate, or personal guarantees.</li>
                        <li><strong>Quick access:</strong> Faster approval and disbursement compared to traditional financing.</li>
                        <li><strong>Tax advantages:</strong> Interest may be deductible as a business expense.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Eligibility Criteria</h3>
                    <ul className="info-eligibility-list-smco">
                        <li><strong>Business type:</strong> Established businesses in various sectors with steady revenue.</li>
                        <li><strong>Business age:</strong> Typically 2–5 years of operation, though some lenders accept newer businesses.</li>
                        <li><strong>Annual revenue:</strong> Minimum turnover of ₹50 lakhs to ₹5 crores, depending on the lender.</li>
                        <li><strong>Credit score:</strong> Strong personal and business credit, usually above 700.</li>
                        <li><strong>Financials:</strong> Profit and loss statements, balance sheets, and cash flow projections.</li>
                        <li><strong>Documentation:</strong> Business licenses, tax returns, bank statements, and collateral details.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Interest Rates and Charges</h3>
                    <p>
                        Rates range from 5% to 25% per annum, with secured loans at the lower end. Fees include processing charges (0.5%–2%), legal fees, and valuation costs. Early repayment may incur penalties, and some loans have annual fees for credit lines.
                    </p>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits of Commercial Loans</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Business expansion:</strong> Fund new locations, equipment, or market expansion.</li>
                        <li><strong>Cash flow management:</strong> Bridge gaps during slow periods or seasonal fluctuations.</li>
                        <li><strong>Asset acquisition:</strong> Purchase property or machinery to improve operations.</li>
                        <li><strong>Debt consolidation:</strong> Refinance high-interest debt at lower rates.</li>
                        <li><strong>Credit building:</strong> Timely repayments enhance business credit for future borrowing.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default CommercialLoanInfo;
